var lib_core = require("lib-core");
var cio_datamodel = require("cio-datamodel");
var DfnPadGeneratorInteractionModel = require('./dfnPadGeneratorInteractionModel.js');
var PackageGeneratorInspectorConfig = require("../../packageGeneratorInspectorConfig.js");

var Dfn2PadGeneratorInteractionModel = function(parametricData, userSettingsModel, showFootprintParams, withCustomFootprintParams) {
    DfnPadGeneratorInteractionModel.call(this, parametricData, userSettingsModel, showFootprintParams, withCustomFootprintParams);
};

lib_core.inherit(Dfn2PadGeneratorInteractionModel, DfnPadGeneratorInteractionModel);
Dfn2PadGeneratorInteractionModel.$class = 'Dfn2PadGeneratorInteractionModel';

module.exports = Dfn2PadGeneratorInteractionModel;

Dfn2PadGeneratorInteractionModel.prototype.getInspectorElementForPitch = function() {
    return [PackageGeneratorInspectorConfig.getValueFixedUnit('e', this.LCLZ('pinPitch', 'Pin Pitch'), this.horizontalPinPitch, this.userSettingsModel.distanceUnit)];
};

Dfn2PadGeneratorInteractionModel.prototype.componentFamilyList = function() {
    var FamilyList = [];

    for (var t in cio_datamodel.IpcDataModel.ComponentAttribute.dfnComponentFamily.DFN_2) {
        var c = cio_datamodel.IpcDataModel.ComponentAttribute.dfnComponentFamily.DFN_2[t];
        FamilyList.push([this.LCLZ(t, c), c]);
    }

    return FamilyList;
};
